var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 24C12.6569 24 14 22.6569 14 21H8C8 22.6569 9.34315 24 11 24Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.87737L9.80421 3.11888C7.06329 3.67243 5.00003 6.09694 5.00003 9C5.00003 9.94174 4.79849 12.2959 4.31173 14.6132C4.0701 15.7636 3.74681 16.9614 3.31714 18H18.6829C18.2532 16.9614 17.9299 15.7636 17.6883 14.6132C17.2016 12.2959 17 9.94173 17 9C17 6.09693 14.9368 3.6724 12.1958 3.11887L11 2.87737ZM20.329 18C20.6638 18.6711 21.0522 19.2015 21.5 19.5H0.5C0.94779 19.2015 1.33617 18.6711 1.67105 18C3.01883 15.2991 3.50003 10.3187 3.50003 9C3.50003 5.36901 6.0803 2.34067 9.50726 1.64856C9.50246 1.59969 9.5 1.55013 9.5 1.5C9.5 0.671573 10.1716 0 11 0C11.8284 0 12.5 0.671573 12.5 1.5C12.5 1.55013 12.4975 1.59968 12.4927 1.64855C15.9197 2.34063 18.5 5.36899 18.5 9C18.5 10.3187 18.9812 15.2991 20.329 18Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBell);
export default __webpack_public_path__ + "static/media/ico-bell.cc61c5298fa9a639e5756e66a7d63231.svg";
export { ForwardRef as ReactComponent };